package com.karawek.core.ui.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.material3.MaterialTheme

val LocalKarawekColors = staticCompositionLocalOf<CoreColorScheme> {
    error("Karawek colors not provided")
}

val LocalKarawekTypography = staticCompositionLocalOf<CoreTypographyScheme> {
    error("Karawek typography not provided")
}

val LocalIsDarkTheme = staticCompositionLocalOf<Boolean> {
    error("IsDarkTheme not provided")
}

object CoreTheme {
    val colors: CoreColorScheme
        @Composable get() = LocalKarawekColors.current

    val typography: CoreTypographyScheme
        @Composable get() = LocalKarawekTypography.current

    val isDarkTheme: Boolean
        @Composable get() = LocalIsDarkTheme.current
}

@Composable
fun CoreTheme(
    colors: CoreColorScheme,
    isDarkTheme: Boolean,
    content: @Composable () -> Unit,
) {
    val typography = createCoreTypographyScheme()

    CompositionLocalProvider(
        LocalKarawekColors provides colors,
        LocalKarawekTypography provides typography,
        LocalIsDarkTheme provides isDarkTheme,
    ) {
        MaterialTheme(
            colorScheme = colors.toMaterialColorScheme(isDarkTheme),
            typography = typography.toMaterialTypography(),
        ) {
            content()
        }
    }
}

@Composable
fun CoreTheme(
    lightColors: CoreColorScheme,
    darkColors: CoreColorScheme,
    themeMode: ThemeMode = ThemeMode.System,
    content: @Composable () -> Unit,
) {
    val isDarkTheme = when (themeMode) {
        ThemeMode.System -> isSystemInDarkTheme()
        ThemeMode.Dark -> true
        ThemeMode.Light -> false
    }

    CoreTheme(
        colors = if (isDarkTheme) darkColors else lightColors,
        isDarkTheme = isDarkTheme,
        content = content,
    )
}
